module.exports = __webpack_public_path__ + "img/m_ban1.a2977b1e.png";